import {
  Controller,
  Control,
  UseFormSetValue,
  UseFormWatch,
  UseFormClearErrors,
} from 'react-hook-form';
import { useState } from 'react';
import SharedAutocomplete from '../../../../../../shared/shared-autocomplete.tsx';
import AvatarChip from '../../../../../../shared/avatar-chip.tsx';
import { DecomPolicyFormValues } from '../../decom-policy-form-layout.tsx';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface DecomNotifyUsersInputProps {
  day: number;
  idx: number;
  control: Control<DecomPolicyFormValues>;
  watch: UseFormWatch<DecomPolicyFormValues>;
  setValue: UseFormSetValue<DecomPolicyFormValues>;
  clearErrors: UseFormClearErrors<DecomPolicyFormValues>;
}

export default function DecomNotifyUsersInput({
  day,
  idx,
  control,
  watch,
  setValue,
  clearErrors,
}: DecomNotifyUsersInputProps) {
  const userToNotify =
    watch(`actions.${day}.actions.${idx}.userToNotify`) || [];
  const [autoCompleteResponse, setAutoCompleteResponse] = useState('');

  const handleSetUserToNotify = (newEmail: string) => {
    if (newEmail && !userToNotify.includes(newEmail)) {
      const updatedUsers = [...userToNotify, newEmail];
      setValue(`actions.${day}.actions.${idx}.userToNotify`, updatedUsers, {
        shouldDirty: true,
      });
      clearErrors(`actions.${day}.actions.${idx}.userToNotify`);
      setValue(
        `actions.${day}.actions.${idx}.notifyUser`,
        updatedUsers.length > 0,
        { shouldDirty: true }
      );
    }
    setAutoCompleteResponse('');
  };

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" fontWeight={600} gutterBottom>
        Set Emails to Notify
      </Typography>
      <Controller
        name={`actions.${day}.actions.${idx}.userToNotify`}
        control={control}
        render={() => (
          <Box sx={{ width: 400 }}>
            <SharedAutocomplete
              sources={['users', 'groups']}
              autocompleteValue={autoCompleteResponse}
              setAutoCompleteValue={handleSetUserToNotify}
            />
          </Box>
        )}
      />
      {userToNotify?.length > 0 && (
        <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {userToNotify.map((email) => (
            <AvatarChip
              key={email}
              type="Unknown"
              email={email}
              onDelete={() => {
                const updated = userToNotify.filter((e) => e !== email);
                setValue(
                  `actions.${day}.actions.${idx}.userToNotify`,
                  updated,
                  { shouldDirty: true }
                );
                setValue(
                  `actions.${day}.actions.${idx}.notifyUser`,
                  updated.length > 0,
                  { shouldDirty: true }
                );
              }}
              size="small"
            />
          ))}
        </Box>
      )}
    </Stack>
  );
}
